import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ArrowLeftIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M12.8417 13.825L9.02508 10L12.8417 6.175L11.6667 5L6.66675 10L11.6667 15L12.8417 13.825Z" />
  </Icon>
);

export default memo(ArrowLeftIcon);
